let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6xZAj")).then(() => parcelRequire('99nv3'));